import { Component, inject, Input, ViewEncapsulation } from '@angular/core';
import { PageTitleComponent } from '@shared/components/page-title/page-title.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Resources } from '@app/resources';
import { BaseLoadComponent } from '@shared/components/classes/base-load.component';
import { Observable } from 'rxjs';
import { LocalizedDatePipe } from '@shared/pipes/localized-date.pipe';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { UtilityTypeBadgeComponent } from '@shared/components/utility-type-badge/utility-type-badge.component';
import { SpinnerComponent } from '@shared/components/spinner/spinner.component';
import { PaginatorModule } from '@primeng/paginator';
import { ReactiveFormsModule } from '@angular/forms';
import { InvoicesService } from '@modules/universal-billing/billing/invoice/invoices.service';
import { InvoiceCardComponent } from '@modules/universal-billing/billing/invoice/invoice-card/invoice-card.component';

@Component({
  selector: 'app-invoice-details',
  standalone: true,
  imports: [PageTitleComponent, TranslatePipe, RouterLink, LocalizedDatePipe, CurrencyPipe, UtilityTypeBadgeComponent, SpinnerComponent, DatePipe, PaginatorModule, ReactiveFormsModule, InvoiceCardComponent],
  templateUrl: './invoice-details.component.html',
  styleUrl: './invoice-details.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class InvoiceDetailsComponent extends BaseLoadComponent<any> {
  @Input() id: number;

  override loadOnInit = false;

  public breadCrumbItems = [];

  protected translateService = inject(TranslateService);
  protected invoicesService = inject(InvoicesService);
  protected route = inject(ActivatedRoute);

  getData(): Observable<any> {
    return this.invoicesService.getOne(this.id);
  }

  ngOnInit(): void {
    this.breadCrumbItems = [
      {label: this.translateService.instant('INVOICES.INVOICE'), link: Resources.Invoices},
      {label: this.id},
      {label: this.translateService.instant('INVOICES.INVOICE_DETAILS'), active: true}
    ];
    super.ngOnInit();

    this.route.params.subscribe(params => {
      if (params.id) {
        this.id = params.id;
        this.loadData();
      }
    })
  }
}
